"use client";

import type { VideoArtifactData } from "@/ai/artifacts/video";
import Image from "next/image";

type Props = {
  data: VideoArtifactData;
};

function VideoArtifactHeader({ title }: { title: string }) {
  return (
    <div className="shrink-0 p-5 border-b border-gray-100 dark:border-white/10 bg-gradient-to-r from-[var(--mindup-pink-light)]/40 to-[var(--mindup-mint)]/40 dark:from-[var(--mindup-plum)]/20 dark:to-[var(--mindup-deep-green)]/10">
      <div className="flex items-center gap-2.5 mb-1.5">
        <Image
          src="/brand/avatars/MindUP_Avatars_RGB_BrainAvatar.png"
          alt="MindUP"
          width={32}
          height={32}
          className="w-8 h-8 rounded-full shadow-sm"
        />
        <h2 className="text-base font-bold text-[var(--mindup-soft-black)] dark:text-white">
          {title}
        </h2>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 ml-10">
        MindUP video
      </p>
    </div>
  );
}

export function VideoCanvas({ data }: Props) {
  return (
    <div className="h-full flex flex-col overflow-hidden bg-white dark:bg-[var(--mindup-soft-black)]">
      <VideoArtifactHeader title={data.title} />
      <div className="flex-1 overflow-auto p-6 flex flex-col items-center">
        <div className="w-full max-w-2xl rounded-xl overflow-hidden bg-black shadow-lg">
          <video
            key={data.url}
            controls
            className="w-full aspect-video"
            preload="metadata"
            poster=""
          >
            <source src={data.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
}
